import { find, result, toUpper } from 'lodash'

const RDATA =
{
	SRV: ({ priority, weight, port, data }) => ({ priority, weight, port, target: data }),
	CAA: ({ flag, tag, value })             => ({ flag, tag, value }),
	MX:  ({ data, preference })             => ({ data, preference }),
}

const RDATA_DEFAULT = ({ data }) => ({ data })

export default function recordPayload(model, { zoneRecordTypes, zoneSOAs } = {})
{
	const { type, soa, name } = model

	const recordType = find(zoneRecordTypes, entry => Number(entry.id) === Number(type))
	const rrType     = toUpper(result(recordType, 'name'))

	const soaEntry   = find(zoneSOAs, entry => Number(entry.id) === Number(soa))

	const payload =
	{
		name,
		rr_type_id: Number(type),
		ttl:        soaEntry ? soaEntry.caching : null,
		auto_ptr:   false,
		data:       null,
		preference: null,
	}

	return { ...payload, ...( RDATA[rrType] ?? RDATA_DEFAULT )(model) }
}
